import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityIncidentLogExportSlice } from './post';

export const coreDataSecurityIncidentLogExportReducers = combineReducers({
	post: postCoreDataSecurityIncidentLogExportSlice.asyncReducers
});

export const coreDataSecurityIncidentLogExportWatchers = combineAllWatchers([
	postCoreDataSecurityIncidentLogExportSlice.asyncWatchers
]);
